import { AccrualReviewStatus } from "@common/types/financialDocument";
import { AccrualDocumentImporterMode } from "../accrualDocumentImporter.lib";

const SHARED_REVIEW_STATUS_LABELS = {
    [AccrualReviewStatus.WRONG_WORKSPACE]: "Wrong workspace",
    [AccrualReviewStatus.WRONG_ENTITY]: "Wrong entity",
    [AccrualReviewStatus.EXTRACTION_FAILED]: "Extraction failed",
    [AccrualReviewStatus.MISSING_FIELDS]: "Missing fields",
    [AccrualReviewStatus.TOTALS_MISMATCH]: "Totals mismatch",
    [AccrualReviewStatus.DUPLICATE]: "Duplicate",
    [AccrualReviewStatus.FOREIGN_CURRENCY]: "Foreign currency",
    [AccrualReviewStatus.PERIOD_LOCKED]: "Closed period",
    [AccrualReviewStatus.PARTIALLY_PAID]: "Partially paid",
    [AccrualReviewStatus.CONFIRM_ACCOUNTS]: "Confirm accounts",
    [AccrualReviewStatus.CONFIRM_ITEMS]: "Confirm items",
    [AccrualReviewStatus.MULTIPLE_ISSUES]: "Multiple issues",
    [AccrualReviewStatus.COUNTERPARTY_CHANGED]: "Counterparty changed",
};

const INVOICE_REVIEW_STATUS_LABELS: Record<AccrualReviewStatus, string> = {
    ...SHARED_REVIEW_STATUS_LABELS,
    [AccrualReviewStatus.NOT_ACCRUAL_DOCUMENT]: "Not an invoice",
    [AccrualReviewStatus.CONFIRM_COUNTERPARTY]: "Confirm customer",
    [AccrualReviewStatus.COUNTERPARTY_REQUIRED]: "Customer required",
};

const BILL_REVIEW_STATUS_LABELS: Record<AccrualReviewStatus, string> = {
    ...SHARED_REVIEW_STATUS_LABELS,
    [AccrualReviewStatus.NOT_ACCRUAL_DOCUMENT]: "Not a bill",
    [AccrualReviewStatus.CONFIRM_COUNTERPARTY]: "Confirm vendor",
    [AccrualReviewStatus.COUNTERPARTY_REQUIRED]: "Vendor required",
};

const INVOICE_COPY = {
    dateLabel: "Invoice date",
    numberLabel: "Invoice number",
    partySubtitle: "To",
    customerPlaceholder: "Select customer",
    confirmSuggestedLabel: "Confirm suggested customer",
    changedDetailsTask: "Review changed customer details",
    changedDetailsLoadError: "Failed to load customer details",
    newCounterpartyAction: "Create customer",
    skipChangedDetailsError: "Failed to skip customer changes",
    discardTooltip: "Confirm the invoice to import it.",
    missingEntity: "Add a business entity before reviewing an invoice.",
    reviewStatusLabels: INVOICE_REVIEW_STATUS_LABELS,
};

const BILL_COPY = {
    dateLabel: "Bill date",
    numberLabel: "Bill number",
    partySubtitle: "Vendor",
    customerPlaceholder: "Select vendor",
    confirmSuggestedLabel: "Confirm suggested vendor",
    changedDetailsTask: "Review changed vendor details",
    changedDetailsLoadError: "Failed to load vendor details",
    newCounterpartyAction: "Create vendor",
    skipChangedDetailsError: "Failed to skip vendor changes",
    discardTooltip: "Confirm the bill to import it.",
    missingEntity: "Add a business entity before reviewing a bill.",
    reviewStatusLabels: BILL_REVIEW_STATUS_LABELS,
};

export type AccrualDraftCopy = typeof INVOICE_COPY | typeof BILL_COPY;

export function accrualDraftCopy(
    mode: AccrualDocumentImporterMode,
): AccrualDraftCopy {
    if (mode === "bills") {
        return BILL_COPY;
    }
    return INVOICE_COPY;
}
